import { types } from 'mobx-state-tree';

// Types
import { Kiosk, KioskDecorated } from '@common/models/kiosks/types';

export default types.optional(types.map(types.frozen<KioskDecorated>()), {});
